import type {ReactElement} from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import styles from './entity-card-skeleton.module.scss';

/**
 * Transient placeholder echoing the entity-card shape (a row with a cover thumbnail and
 * title + meta lines), shown while an event is being published. Its dimensions are its
 * own — it is not a pixel-exact match of the card. Replaced by the agent's streamed
 * confirmation and the real entity card.
 */
export function EntityCardSkeleton(): ReactElement {
  return (
    <div className={styles.root}>
      <SkeletonBrick className={styles.media} theme={SkeletonBrickTheme.AI_ROTATING_GRADIENT} />
      <div className={styles.text}>
        <SkeletonBrick className={styles.titleLine} height={16} radius={'4px'} />
        <SkeletonBrick className={styles.metaLine} height={14} radius={'4px'} />
      </div>
    </div>
  );
}
